export enum MapNetFilterType {
  AREA = 0,
  NET = 1,
}
